import { render, staticRenderFns } from "./values.vue?vue&type=template&id=d0aa0254&scoped=true"
import script from "./values.vue?vue&type=script&lang=js"
export * from "./values.vue?vue&type=script&lang=js"
import style0 from "./values.vue?vue&type=style&index=0&id=d0aa0254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0aa0254",
  null
  
)

export default component.exports